// removed by extract-text-webpack-plugin
module.exports = {"Header":"src-components----index-page-module---Header---SNOol","Header_photo":"src-components----index-page-module---Header_photo---xkCG5","Title":"src-components----index-page-module---Title---3_e5-","Subtitle":"src-components----index-page-module---Subtitle---1-peb","PostPreview":"src-components----index-page-module---PostPreview---3HF9l","ReadMore":"src-components----index-page-module---ReadMore---9U9Di"};


//////////////////
// WEBPACK FOOTER
// ./src/components/index-page.module.css
// module id = 60
// module chunks = 168707334958949